export const cateringPageTranslations = {
  nl: {
    title: "Catering Diensten",
    subtitle: "Laat Ams Food Market de authentieke smaken van de Indiase, Sri Lankaanse en Surinaamse keuken naar uw speciale evenement brengen. Wij cateren voor maximaal 100 personen!",
    menuTitle: "Sri Lankaanse / Indiase gerechten",
    markedDishesNote: "Alle gemarkeerde gerechten worden geserveerd met bijpassende chutney en een heerlijke groente curry (sambar).",
    dishes: {
      idly: "IDLY",
      idlyDesc: "Zacht gestoomde rijstcake.",
      vada: "VADA",
      vadaDesc: "Bara uit Sri Lanka / India",
      idiyappam: "IDIYAPPAM",
      idiyappamDesc: "String hopper",
      dosa: "DOSA",
      dosaDesc: "Sri Lankaanse / Indiase versie.",
      loempiaRoll: "LOEMPIA ROLL",
      loempiaRollDesc: "Vegetarisch, kip of lams.",
      kottuRoti: "KOTTU ROTI",
      kottuRotiDesc: "Vegetarisch, kip of lams.",
      rijstMetCurry: "RIJST MET CURRY",
      rijstMetCurryDesc: "Ook als vegetarisch gerecht mogelijk.",
    },
    impressionTitle: "Een Impressie van onze catering",
    image1Alt: "Catering gerecht 1 - Idly schotel",
    image2Alt: "Catering gerecht 2 - Vada schotel",
    eventsTitle: "Wij cateren voor verjaardagen, jubilea, bedrijfsfeesten, familiebijeenkomsten en meer!",
    planEventTitle: "Plan Uw Evenement Met Ons",
    planEventText: "Of het nu gaat om een feest, zakelijke bijeenkomst of een gezellige familielunch: wij verzorgen de catering volledig naar jouw wensen. Alles is bespreekbaar – van menu en porties tot dieetwensen of speciale verzoeken.\n\nAarzel niet om contact met ons op te nemen – wij denken graag met je mee voor een smaakvolle ervaring!",
    contactButton: "Neem contact op",
  },
  en: {
    title: "Catering Services",
    subtitle: "Let Ams Food Market bring the authentic flavors of Indian, Sri Lankan, and Surinamese cuisine to your special event. We cater for up to 100 people!",
    menuTitle: "Sri Lankan / Indian dishes",
    markedDishesNote: "All marked dishes are served with matching chutney and a delicious vegetable curry (sambar).",
    dishes: {
      idly: "IDLY",
      idlyDesc: "Soft steamed rice cake.",
      vada: "VADA",
      vadaDesc: "Bara from Sri Lanka / India",
      idiyappam: "IDIYAPPAM",
      idiyappamDesc: "String hopper",
      dosa: "DOSA",
      dosaDesc: "Sri Lankan / Indian version.",
      loempiaRoll: "SPRING ROLL",
      loempiaRollDesc: "Vegetarian, chicken or lamb.",
      kottuRoti: "KOTTU ROTI",
      kottuRotiDesc: "Vegetarian, chicken or lamb.",
      rijstMetCurry: "RICE WITH CURRY",
      rijstMetCurryDesc: "Also available as a vegetarian dish.",
    },
    impressionTitle: "An Impression of our catering",
    image1Alt: "Catering dish 1 - Idly platter",
    image2Alt: "Catering dish 2 - Vada platter",
    eventsTitle: "We cater for birthdays, anniversaries, corporate parties, family gatherings, and more!",
    planEventTitle: "Plan Your Event With Us",
    planEventText: "Whether it's a party, business meeting, or a cozy family lunch: we provide catering completely to your wishes. Everything is discussable – from menu and portions to dietary needs or special requests.\n\nDo not hesitate to contact us – we are happy to think along with you for a tasteful experience!",
    contactButton: "Contact us",
  },
};